import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2abd3252&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2abd3252&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abd3252')) {
      api.createRecord('2abd3252', component.options)
    } else {
      api.reload('2abd3252', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2abd3252&", function () {
      api.rerender('2abd3252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalConsultationDetail/index.vue"
export default component.exports